<script setup>
import { ref, computed, onMounted } from 'vue';
import { watchDebounced } from '@vueuse/core';
import { useMainStore } from './store/main';
import ConfirmPopup from './components/ConfirmPopup.vue';
import ReviewPopup from './components/ReviewPopup.vue';
import { useApi } from './composables/useApi';
import Form from './components/Form.vue';

const { setDraft, updateDraft: sendDraftUpdate, getBreeds } = useApi();

// породы нужны первым же полем формы — грузим заранее, до открытия попапа
getBreeds('dog');
getBreeds('cat');
const mainStore = useMainStore();

const isPopupOpen = ref(false);

let watcher;
let isProcessing = false;

const createDraft = async (obj, el) => {
	const response = await setDraft(obj, el);

	if (!response)
		return;

	mainStore.sesson_id = response.session_id;
	obj.draft_id        = response.draft_id;
	el.pet_id           = response.pet_id;
}

// при смене времени сервер пересоздаёт черновик с новым id — без этого
// следующие изменения и удаление шли бы по старому, уже несуществующему id
const updateDraft = async (obj, el) => {
	const response = await sendDraftUpdate(obj, el);

	if (response)
		obj.draft_id = response.draft_id;
	// добавленные услуги не влезли в выбранное время — сбрасываем его,
	// слоты пересчитаются под новую длительность
	else if (obj.status == 'draft') {
		obj.date = null;
		obj.time = null;
	}
}

const mode = computed(() => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('mode');
});

const checkDraft = (draft, pet) => {
	const allKeysExist = [
		'name',
		'status',
		'master',
		'services',
		'date',
		'time',
	].every(key => key in draft && draft[key]);

	if (!allKeysExist)
		return 

	const service_ids = draft.services.map(el => el.id);
	const master_id   = draft.master.id;

	draft.service_ids = service_ids;
	draft.master_id   = master_id;

	return !draft.draft_id ? createDraft(draft, pet) : updateDraft(draft, pet);
}

const stopWatcher = () => watcher?.();
const startWatcher = () => {
	watcher = watchDebounced(() => mainStore.formData, async value => {
		if (isProcessing) return;
		
		isProcessing = true;
		stopWatcher();

		try {
			for (const el of value) {
				// ждём ответ по каждому черновику: иначе следующее срабатывание
				// вотчера не видит draft_id и создаёт дубль, занимая слот дважды
				for (const obj of el.drafts) {
					try {
						if (!obj.draft_id) {
							if (obj.status == 'need_feedback' && obj.comment)
								await createDraft(obj, el);
							else if (obj.status == 'draft')
								await checkDraft(obj, el);
						} else {
							if (obj.status == 'need_feedback' && obj.comment)
								await updateDraft(obj, el);
							else if (obj.status == 'draft')
								await checkDraft(obj, el);
						}
					}	catch {}
				}
			}
		} finally {
			setTimeout(() => {
				startWatcher();
				isProcessing = false;
			}, 300);
		}
	}, { debounce: 800, deep: true });
};

onMounted(() => {
	if (mode.value)
		isPopupOpen.value = true;
})

startWatcher();
</script>

<template>
	<div>
		<Form />
		<ReviewPopup
			v-model="isPopupOpen"
			v-if="mode == 'review' && isPopupOpen"
		/>
		<ConfirmPopup
			v-model="isPopupOpen"
			v-else-if="mode == 'cancel_appointment' && isPopupOpen"
		/>
	</div>
</template>

<style lang='scss'>
</style>